import * as React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardFooter,
  Divider,
  Link,
  Text,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import { Call24Filled } from "@fluentui/react-icons";

const useStyles = makeStyles({
  container: {
    position: "relative",
    minHeight: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
    backgroundImage:
      "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
  },
  card: {
    maxWidth: "450px",
    width: "100%",
    margin: "0 auto",
    boxShadow:
      "hsl(220deg 30% 5% / 8%) 0px 5px 15px 0px, hsl(220deg 25% 10% / 12%) 0px 15px 35px -5px",
    ...shorthands.borderRadius("16px"),
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    rowGap: "16px",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "8px",
  },
  title: {
    fontSize: "clamp(1.5rem, 10vw, 1.5rem)",
    fontWeight: 600,
  },
  icon: {
    fontSize: "clamp(1.5rem, 10vw, 1.5rem)",
    width: "1em",
    height: "1em"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    rowGap: "12px",
    width: "100%",
  },
  button: {
    textTransform: "none",
  },
  footerTextWrapper: {
    width: "100%",
    display: "flex",
    rowGap: "8px",
    alignItems: "center",
    justifyContent: "center",
  },
  footerText: {
    textAlign: "center",
  },
});

export default function AdminSignIn({ onLogin, title = "Unaric Voice for Teams Admin" }) {
  const styles = useStyles();

  const handleRedirect = () => {
    onLogin && onLogin();
  };

  return (
    <div className={styles.container}>
      <Card className={styles.card} appearance="filled">
        {/* Header */}
        <CardHeader
          header={
            <div className={styles.headerRow}>
              <Call24Filled className={styles.icon} />
              <Text as="h1" className={styles.title}>
                {title}
              </Text>
            </div>
          }
        />

        {/* Sign-in button */}
        <div className={styles.form}>
          <Button
            appearance="primary"
            size="large"
            className={styles.button}
            onClick={handleRedirect}
          >
            Login
          </Button>
        </div>

        {/* Divider */}
        <Divider>
          <Text>or</Text>
        </Divider>

        {/* Footer text / contact link */}
        <CardFooter>
          <div className={styles.footerTextWrapper}>
            <Text className={styles.footerText}>
              Not on Unaric Voice for Teams yet? <Link href="https://www.unaric.com/contact-us" target="_blank" rel="noopener noreferrer">Contact us</Link>
            </Text>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}
